import { useLocation, useNavigate, NavigateOptions } from "@reach/router";

import { useMemo } from "react";

export interface ArraySearchParamActions<T> {
  setValue: (s: T[]) => void;
  add: (s: T) => void;
  remove: (s: T) => void;
  clear: () => void;
}

interface ArraySearchParamOptions<T> {
  initialize: (s: string[]) => T[];
}

export default function useArraySearchParam<T>(
  name: string,
  options: ArraySearchParamOptions<T> & NavigateOptions<{}>
): [T[], ArraySearchParamActions<T>] {
  const location = useLocation();
  const navigate = useNavigate();

  const { initialize, ...navigationOptions } = options;

  const params = new URLSearchParams(location.search);
  const values = initialize(params.get(name)?.split(",") ?? []);

  const actions = useMemo(() => {
    const setValue = (s: T[]) => {
      params.set(name, s.join(","));

      navigate(`${location.pathname}?${params.toString()}`, navigationOptions);
    };
    const add = (s: T) => {
      params.set(
        name,
        values
          .filter((v) => v !== s)
          .concat([s])
          .join(",")
      );

      navigate(`${location.pathname}?${params.toString()}`, navigationOptions);
    };
    const remove = (s: T) => {
      console.log(values);
      params.set(name, values.filter((v) => v !== s).join(","));

      navigate(`${location.pathname}?${params.toString()}`, navigationOptions);
    };
    const clear = () => {
      params.delete(name);

      navigate(`${location.pathname}?${params.toString()}`, navigationOptions);
    };

    return { add, remove, clear, setValue };
  }, [name, values]);

  return [values, actions];
}
